<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout justify-space-between>
          <v-flex v-if="showAddGroupButton">
            <v-btn dark color="primary" @click.stop="addGroupFunc"><v-icon dark>add</v-icon>{{ $t('addGroup') }}</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs8 md2>
            <v-text-field
              append-icon="filter_list"
              :label="$t('search')"
              single-line
              hide-details
              v-model="filter"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-if="$attrs.isRealtime" justify-start align-baseline>
          <v-flex class="success--text caption"><span class="realtime-border px-1">{{ $t('realTIME') }}</span></v-flex>
        </v-layout>
        <v-data-table
          v-if="type === 'users'"
          :headers="headers"
          :items="users"
          class="elevation-2 myDense"
          :search="filter"
          ref="offerTable"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="rowPerPage">
          <template v-slot:progress>
            <v-progress-linear color="blue" indeterminate></v-progress-linear>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
            <td class="text-xs-left">
              <v-layout>{{ $t('email') }}: {{ props.item.email }}</v-layout>
              <v-layout>{{ $t('note') }}: {{ props.item.note }}</v-layout>
            </td>
            <td class="text-xs-left">{{ props.item.balance }}</td>
            <td class="text-xs-center">
              <v-layout row>
                <v-flex v-if="secondFunc && !props.item.requestKey && props.item.status !== 'unsubscribed'"><v-btn class="mx-0" dark color="primary" flat @click.stop="secondFunc(props.item)">{{secondActionText}}</v-btn></v-flex>
                <v-flex v-if="props.item.status === 'unsubscribed'">
                  <v-btn
                    class="mx-0"
                    color="red"
                    flat
                    :loading="props.item.isRemoveLoading"
                    @click.stop="removeUser(props.item)"
                  >{{ $t('remove') }}</v-btn>
                </v-flex>
                <v-flex v-if="props.item.status === 'pending'">
                  <v-btn 
                    class="mx-0" 
                    flat
                    color="primary" 
                    :loading="props.item.isAcceptLoading" 
                    :dark="!props.item.isRejectLoading"
                    :disabled="props.item.isRejectLoading"
                    @click.stop="showSelectGroupDialog(props.item)" 
                    :id="`member${props.index + 1}`"
                  >{{ $t('accept') }}</v-btn>
                </v-flex>
                <v-flex v-if="props.item.status === 'pending'">
                  <v-btn
                    class="mx-0"
                    color="primary"
                    flat
                    :loading="props.item.isRejectLoading"
                    :dark="!props.item.isAcceptLoading"
                    :disabled="props.item.isAcceptLoading"
                    @click.stop="rejectUser(props.item)"
                  >{{ $t('reject') }}</v-btn>
                </v-flex>
                <v-flex v-if="props.item.status !== 'unsubscribed'">
                  <v-btn
                    class="mx-0"
                    color="primary"
                    flat
                    :loading="unsubscribeLoadingMap[props.index]"
                    :dark="!unsubscribeLoadingMap[props.index]"
                    :disabled="unsubscribeLoadingMap[props.index]"
                    @click.stop="unsubscribeUser(props)"
                  >{{ $t('unsubscribe') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
        <v-data-table
          v-else
          :headers="headers2"
          :items="displayGroups"
          class="elevation-2 myDense"
          :search="filter"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="rowPerPage">
          <template v-slot:progress>
            <v-progress-linear color="blue" indeterminate></v-progress-linear>
          </template>
          <template v-slot:items="props">
            <td class="subheading">{{ props.item.name}}</td>
            <td class="text-xs-left">
              <v-chip v-for="member in props.item.members" :key="member.uid">
                {{member.name}}
              </v-chip>
              </td>
            <td class="text-xs-center">
              <v-layout row lg3>
                <v-flex v-if="firstFunc"><v-btn dark color="primary" flat @click.stop="firstFunc(props.item)">{{firstActionText}}</v-btn></v-flex>
                <v-flex v-if="secondFunc"><v-btn dark color="primary" flat @click.stop="secondFunc(props.item)">{{secondActionText}}</v-btn></v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <MemberEdit
      :title="$t('editUser')"
      v-model="selectGroupDialog"
      v-if="selectGroupDialog"
      :isUser="true"
      :isEditGroup="false"
      isRequest
      :user="userInEdit"></MemberEdit>
  </div>
</template>

<script>
import MemberEdit from './MemberEdit'
export default {
  name: 'MemberTable',
  components: {
    MemberEdit
  },
  data () {
    return {
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      pagination: {
        sortBy: 'id'
      },
      filter: '',
      headers: [
        { text: this.$t('index'), align: 'left', sortable: false, value: 'id' },
        { text: this.$t('user'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('status'), align: 'left', sortable: true, value: 'status' },
        { text: this.$t('info'), value: 'email', align: 'left', sortable: false },
        { text: this.$t('balance'), value: 'balance', align: 'left', sortable: true },
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '20%' }
      ],
      headers2: [
        { text: this.$t('name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('users'), value: 'users', align: 'left', sortable: false },
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '20%' }
      ],
      selectGroupDialog: false,
      userInEdit: {},
      unsubscribeLoadingMap: {},
      groupKey: ''
    }
  },
  computed: {
    displayGroups () {
      let groups = this.users
      groups.forEach(group => {
        if (group.members) {
          group.members = Object.values(group.members)
        }
      })
      return groups
    },
    loading () {
      return this.$store.getters.loadingMembers
    }
  },
  methods: {
    showSelectGroupDialog (item) {
      this.selectGroupDialog = true
      this.userInEdit = item
    },
    rejectUser (user) {
      this.$set(user, 'isRejectLoading', true)
      const handleDetail = {
        request: {
          uid: user.uid,
          requestKey: user.requestKey,
          tenantKey: user.tenantKey
        },
        approvalType: 0
      }
      return this.$store.dispatch('rejectUserRequest', handleDetail)
        .finally(() => { user.isRejectLoading = false })
    },
    removeUser (user) {
      if (!confirm(this.$t('confirmRemoveUser'))) return
      this.$set(user, 'isRemoveLoading', true)
      return this.$store.dispatch('removeUser', user)
        .finally(() => { user.isRemoveLoading = false })
    },
    async unsubscribeUser (props) {
      const { item, index } = props
      if (item.status === 'unsubscribed') return
      if (!confirm(this.$t('confirmUnsubscribeName', { name: item.name }))) return Promise.resolve('')
      this.$set(this.unsubscribeLoadingMap, index, true)
      await this.$store.dispatch('unsubscribeUser', item)
        .catch(error => {
          console.error(error)
          this.$store.dispatch('showToast', {info: error.message})
        })
      this.$set(this.unsubscribeLoadingMap, index, false)
    }
  },
  props: {
    users: {
      type: Array,
      default: function () {
        return [{}]
      }
    },
    type: String,
    firstActionText: String,
    firstFunc: Function,
    secondActionText: String,
    secondFunc: Function,
    showAddGroupButton: Boolean,
    addGroupFunc: Function
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MemberTable.vue